'use client'

import { useCallback, useState } from 'react'

import { type LeadPayload } from '@/api/lead'
import { submitLeadService } from '@/services/lead/leadService'
import { toErrorMessage } from '@/shared/errors/appError'

type SubmitLeadResult = {
  ok: boolean
  message?: string
}

export function useLeadForm() {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [error, setError] = useState('')

  const submitLead = useCallback(async (payload: LeadPayload): Promise<SubmitLeadResult> => {
    setError('')
    setIsSubmitting(true)

    try {
      const result = await submitLeadService({
        ...payload,
        pageUrl: typeof window !== 'undefined' ? window.location.href : '',
      })

      setIsSubmitted(true)
      return result
    } catch (submitError) {
      const message = toErrorMessage(submitError, 'Ошибка отправки формы.')
      setError(message)
      return { ok: false, message }
    } finally {
      setIsSubmitting(false)
    }
  }, [])

  const resetLeadStatus = useCallback(() => {
    setError('')
    setIsSubmitted(false)
    setIsSubmitting(false)
  }, [])

  return {
    isSubmitting,
    isSubmitted,
    error,
    submitLead,
    resetLeadStatus,
  }
}
